import { ReactFlagEvaluationOptions } from "@openfeature/react-sdk";

export const FLAGS = {
  account_checklist: ["account-checklist", false],
  workspace_usage: ["workspace-menu-usage", false],
  workspace_audit_log: ["workspace-menu-audit-log", false],
  workspace_billing: ["workspace-menu-billing", false],
  workspace_billing_get_free_credits: ["workspace-menu-billing-get-free-credits", false],
  project_compute: ["project-menu-compute", false],
  project_usage: ["project-menu-usage", false],
  compute_ssh: ["compute-ssh", false],
  runner_custom_runner_size: ["runner-custom-runner-size", false],
  runner_container_registry_option_other: ["runner-container-registry-option-other", false],
  workspace_kpi_cards: ["workspace-kpi-cards", false],
  workspace_billing_kpi: ["workspace-billing-kpi", false],
  project_overview_kpi_cards: ["project-overview-kpi-cards", false],
  notification_billing_option: ["notification-billing-option", false],
  notification_invitation_option: ["notification-invitation-option", false],
  notification_maintenance_option: ["notification-maintenance-option", false],
  notification_runners_option: ["notification-runners-option", false],
  notification_workspace_project_option: ["notification-workspace-project-option", false],
  notification_compute_option: ["notification-compute-option", false],
  notification_menu: ["notification-menu", false],
  runner_container_registry: ["runners-repository-container-registries", false],
  runner_custom_image: ["runners-repository-custom-images", false],
  runner_kpi_cards: ["runners-kpi-cards", false],
  runner_size_sm: ["runner-size-sm", false],
  runner_size_md: ["runner-size-md", false],
  runner_size_md_plus: ["runner-size-md-plus", false],
  runner_size_lg: ["runner-size-lg", false],
  runner_size_lg_plus: ["runner-size-lg-plus", false],
  runner_size_xl: ["runner-size-xl", false],
  runner_size_xxl: ["runner-size-xxl", false],
  runner_create_runner: ["runners-create-custom-runner", false],
  workspace_members_archived_members: ["workspace-members-archived-members", false],
  profile_email_change: ["profile-email-change", false],
  runner_is_autoscale: ["runner-is-autoscale", false],
  workspace_billing_activity: ["workspace-billing-activity", false],
  github_sso: ["github-sso", false],
  cumulative_billing_stats: ["cumulative-billing-stats", false],
} satisfies Record<string, [flagKey: string, defaultValue: boolean, options?: ReactFlagEvaluationOptions]>;

export type FlagType = keyof typeof FLAGS;
